<div
  [hidden]="false">

  <mat-expansion-panel [expanded]="filterValue == 'all'">
    <mat-expansion-panel-header>
      <mat-panel-title class="panel-title" fxLayout="row">
        
        <div class=question-title>
          {{ question.QuestionTitle }}
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="question-text" [innerHTML]="question.QuestionText | safeHtml"></div>

  </mat-expansion-panel>
</div>
